import React from 'react';
import propTypes from 'prop-types';
import { Button, Columns, Column, ModalCardBody, ModalCardHeader, ModalCardTitle, ModalCard, ModalBackground, Modal, Control, Field as BulmaField } from 'src/ui/mui-ui-kit';
import { usePoseWithBulma } from 'src/ui/hooks';
import {
  FadeInDiv,
  AnimatedCard,
  InnerLoader,
  submitAndReset,
  UiQuillAdapter,
} from 'src/ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Form, Field } from 'react-final-form';
import { composeValidators, required } from 'src/ui/validations';

export function LocationNotesModal({ isActive, onCancel, onSubmit, action, initialNotes }) {
  // Use a key that changes when the modal opens to force form remount
  const formKey = React.useMemo(() => `notes-${Date.now()}`, [isActive]);

  // Don't render anything if modal is not active
  if (!isActive) {
    return null;
  }

  return (
    <Form
      key={formKey}
      onSubmit={onSubmit}
      initialValues={{ notes: initialNotes }}
      render={({ form, hasValidationErrors, submitting, handleSubmit }) => {
        const submit = submitAndReset(handleSubmit, form);

        return (
          <form onSubmit={submit}>
            <Modal
              isActive={isActive}
              className="location-notes-modal"
            >
              <ModalBackground onClick={() => onCancel(form)} />
              <ModalCard>
                  <InnerLoader visible={submitting} />
                  <ModalCardHeader>
                    <ModalCardTitle
                      tag="h5"
                      className="has-text-weight-semibold columns is-vcentered"
                    >
                      <Column isSize="narrow" tag="span">
                        <span className="icon is-medium has-icon-gradient-bright">
                          <FontAwesomeIcon icon={['fal', 'file-alt']} size="lg" />
                        </span>
                      </Column>
                      <Column tag="span" hasTextColor="primary" isPaddingless>
                        {action} Location Notes
                      </Column>
                    </ModalCardTitle>
                  </ModalCardHeader>
                  <ModalCardBody>
                    <Columns isMultiline>
                      <Column isSize="full">
                        <Field
                          component={UiQuillAdapter}
                          id="notes"
                          name="notes"
                          label="Location Notes"
                          placeholder="Enter notes about this location..."
                          required={false}
                        />
                      </Column>
                    </Columns>
                    <BulmaField isGrouped="centered">
                      <Control>
                        <Button
                          hasTextColor="info"
                          onClick={() => onCancel(form)}
                        >
                          Cancel
                        </Button>
                      </Control>
                      <Control>
                        <Button
                          isColor="gradient-bright"
                          type="submit"
                          disabled={submitting}
                        >
                          {action}
                        </Button>
                      </Control>
                    </BulmaField>
                  </ModalCardBody>
                </ModalCard>
              </Modal>
          </form>
        );
      }}
    />
  );
}

LocationNotesModal.propTypes = {
  isActive: propTypes.bool.isRequired,
  onCancel: propTypes.func.isRequired,
  onSubmit: propTypes.func.isRequired,
  action: propTypes.string.isRequired,
  initialNotes: propTypes.string,
};

LocationNotesModal.defaultProps = {
  initialNotes: '',
};
